import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  hasMore = false,
  onLoadMore,
  mode = "numbers",
}) {
  if (mode === "loadMore") {
    if (!hasMore) return null;
    return (
      <div className="flex justify-center mt-10">
        <button
          onClick={onLoadMore}
          className="px-6 py-3 rounded-full bg-white border border-gray-200 text-xs font-bold text-gray-700 hover:border-[#7C3AED] hover:text-[#7C3AED] shadow-sm hover:shadow transition duration-200"
        >
          Load More Results
        </button>
      </div>
    );
  }

  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-1.5 mt-10">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="p-2 rounded-xl bg-white border border-gray-200 text-gray-500 hover:border-[#7C3AED] hover:text-[#7C3AED] disabled:opacity-50 disabled:pointer-events-none transition shadow-sm"
        aria-label="Previous page"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>

      {pages.map((p) => {
        const isActive = p === currentPage;
        return (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={`w-9 h-9 rounded-xl text-xs font-bold transition shadow-sm ${
              isActive
                ? "bg-[#7C3AED] text-white border-transparent"
                : "bg-white border border-gray-200 text-gray-700 hover:border-[#7C3AED] hover:text-[#7C3AED]"
            }`}
          >
            {p}
          </button>
        );
      })}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="p-2 rounded-xl bg-white border border-gray-200 text-gray-500 hover:border-[#7C3AED] hover:text-[#7C3AED] disabled:opacity-50 disabled:pointer-events-none transition shadow-sm"
        aria-label="Next page"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
}
